var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.525,
    y: 0.525,
    width: 19.95,
    height: 19.95,
    rx: 9.975,
    fill: "white",
    fillOpacity: 0.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.525,
    y: 0.525,
    width: 19.95,
    height: 19.95,
    rx: 9.975,
    stroke: "white",
    strokeWidth: 1.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.499 8.086V13H9.302V10.053L8.203 13H7.237L6.131 10.046V13H4.934V8.086H6.348L7.727 11.488L9.092 8.086H10.499ZM13.6838 13.049C13.2218 13.049 12.7971 12.9417 12.4098 12.727C12.0271 12.5123 11.7214 12.2137 11.4928 11.831C11.2688 11.4437 11.1568 11.0097 11.1568 10.529C11.1568 10.0483 11.2688 9.61667 11.4928 9.234C11.7214 8.85133 12.0271 8.55267 12.4098 8.338C12.7971 8.12333 13.2218 8.016 13.6838 8.016C14.1458 8.016 14.5681 8.12333 14.9508 8.338C15.3381 8.55267 15.6414 8.85133 15.8608 9.234C16.0848 9.61667 16.1968 10.0483 16.1968 10.529C16.1968 11.0097 16.0848 11.4437 15.8608 11.831C15.6368 12.2137 15.3334 12.5123 14.9508 12.727C14.5681 12.9417 14.1458 13.049 13.6838 13.049ZM13.6838 11.957C14.0758 11.957 14.3884 11.8263 14.6218 11.565C14.8598 11.3037 14.9788 10.9583 14.9788 10.529C14.9788 10.095 14.8598 9.74967 14.6218 9.493C14.3884 9.23167 14.0758 9.101 13.6838 9.101C13.2871 9.101 12.9698 9.22933 12.7318 9.486C12.4984 9.74267 12.3818 10.0903 12.3818 10.529C12.3818 10.963 12.4984 11.3107 12.7318 11.572C12.9698 11.8287 13.2871 11.957 13.6838 11.957Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemo);
export default __webpack_public_path__ + "static/media/Memo.59c9cf76d107d6e5be07acd3c3823016.svg";
export { ForwardRef as ReactComponent };